import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 col-xl-6" }
const _hoisted_3 = { class: "form-card h-100 p-4" }
const _hoisted_4 = { class: "form-floating mb-3" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-floating mb-3" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-floating mb-3" }
const _hoisted_9 = { class: "form-floating mb-3" }
const _hoisted_10 = { class: "form-floating mb-3" }
const _hoisted_11 = { class: "form-floating mb-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "col-sm-12 col-xl-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("h6", { class: "mb-4" }, "Add Stock Dividend", -1)),
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              id: "select-platform",
              "aria-label": "Select Sector",
              name: "platform",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.form.platform_id) = $event))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("option", {
                selected: "",
                value: "0"
              }, "Select Platform", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.platformList, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.platform_id,
                  value: option.platform_id
                }, _toDisplayString(option.name) + " - " + _toDisplayString(option.username), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, $data.form.platform_id]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "select-platform" }, "Select Platform", -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              id: "select-stock",
              "aria-label": "Select Stock",
              name: "stock_id",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.form.stock_id) = $event))
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("option", {
                selected: "",
                value: "0"
              }, "Select Stock", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.stock.filter(stock => stock.platform_id == $data.form.platform_id), (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.stock_id,
                  value: option.stock_id
                }, _toDisplayString(option.name), 9, _hoisted_7))
              }), 128))
            ], 512), [
              [_vModelSelect, $data.form.stock_id]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "select-stock" }, "Select Stock", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.form.qty) = $event)),
              name: "qty",
              class: "form-control",
              id: "qty",
              placeholder: "Quantity"
            }, null, 512), [
              [_vModelText, $data.form.qty]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "qty" }, "Quantity", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.form.amount) = $event)),
              name: "amount",
              class: "form-control",
              id: "amount",
              placeholder: "Amount"
            }, null, 512), [
              [_vModelText, $data.form.amount]
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "amount" }, "Amount", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.form.created_at) = $event)),
              name: "created_at",
              class: "form-control",
              id: "created-at",
              placeholder: "Dividend Date"
            }, null, 512), [
              [_vModelText, $data.form.created_at]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "created-at" }, "Dividend Date", -1))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              disabled: $setup.v$.form.$invalid,
              type: "submit",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.addDividend())),
              class: "btn btn-primary"
            }, " Submit ", 8, _hoisted_12)
          ])
        ], 32)
      ])
    ]),
    (this.stockWiseDividends)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_v_card, {
            flat: "",
            rounded: "lg",
            class: "dividend-table-card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                headers: this.grid.headers,
                items: this.stockWiseDividends,
                "sort-by": [{ key: 'created_at', order: 'desc' }],
                "items-per-page-options": [10, 15, 20, 30, 50, 100, 200],
                "items-per-page": 5,
                "item-value": "name",
                class: "custom-data-table"
              }, {
                top: _withCtx(() => [
                  _createVNode(_component_v_toolbar, { flat: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Total: " + _toDisplayString(this.$helper.formatPrice($options.getTotalDivident())), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider, {
                        class: "mx-4",
                        inset: "",
                        vertical: ""
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            target: "_blank",
                            name: "stoke-view",
                            to: { path: '/stock/view', query: { id: $options.findStockCodeById() }}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($options.findStockCodeById()), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                [`item.qty`]: _withCtx(({ item }) => [
                  _createVNode(_component_v_avatar, {
                    color: $options.getColor(item),
                    size: "36"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.qty), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                [`item.amount`]: _withCtx(({ item }) => [
                  _createElementVNode("span", null, _toDisplayString(this.$helper.formatPrice(item.amount)), 1)
                ]),
                [`item.created_at`]: _withCtx(({ item }) => [
                  _createElementVNode("span", null, _toDisplayString(this.$helper.formatDate(item.created_at, true)), 1)
                ]),
                _: 2
              }, 1032, ["headers", "items"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}